import React, {Component} from 'react';
import NavContentLink from './NavContentLink';
import * as routes from '../../const/routes';
import './NavContent.css';

import IconBuilding from '../../components/Svg/icon-building';
import IconCatalog from '../../components/Svg/icon-catalog';
import Iconlighthouse from '../../components/Svg/icon-lighthouse';
import Iconlight from '../../components/Svg/icon-light';
import IconBuilding1 from '../../components/Svg/icon-building-1';
import { withUiContext } from '../../UiContext';
import CloseBtn2 from '../CloseBtn2';

import Languages from '../../const/languages';

class NavContent extends Component {
    close = () => {
        this.props.onClose();
    }

    render() {
        return (
            <div className = 'nav__content nav__content-main in'>
                <div className = 'nav__content__link-group nav__content__link-group__level-mod in'>
                    <div className = 'nav-row'>
                        <NavContentLink
                            driverStatus
                            introStatus
                            className = 'nav-item-1'
                            icon = { <IconBuilding/> }
                            label = { Languages.zetoPlant }
                            link = { routes.FACTORY2 }
                        />
                    </div>

                    <div className = 'nav-row'>
                        <NavContentLink
                            driverStatus
                            className = 'nav-item-2'
                            icon = { <IconCatalog/> }
                            label = { Languages.products }
                            link = { routes.PROD }
                        />

                        <NavContentLink
                            driverStatus
                            introStatus
                            className = 'nav-item-2'
                            icon = { <Iconlighthouse/> }
                            label = { Languages.substations }
                            link = { routes.PODST }
                        />
                    </div>

                    <div className = 'nav-row'>
                        <NavContentLink
                            driverStatus
                            introStatus
                            className = 'nav-item-4'
                            icon = { <IconBuilding1/> }
                            label = { Languages.projects }
                            link = { routes.PROJECT }
                        />

                        <NavContentLink
                            driverStatus
                            className = 'nav-item-7'
                            icon = { <Iconlight/> }
                            label = { Languages.cooperation }
                            link = { routes.KOOPER }
                        />
                    </div>

                    <div
                        className = 'nav__content__overlay'
                        onClick = { this.close }
                    />

                    <CloseBtn2
                        onClick = { this.close }
                        onMouseEnter = { this.props.ui.playOverSound }
                    />
                </div>

                <div
                    className = 'nav__content__overlay'
                    onClick = { this.close }
                />
            </div>
        );
    }
}

export default withUiContext(NavContent);
